import { CommonOption } from "api/modules/common.option";
import { FormFieldConfig } from "Components/Common/CommonForm";

export const subjectLabelFields = (studyOptions:CommonOption[]): FormFieldConfig[] => [
    {
      name: "studyid",
      label: "Study Code",
      type: "select",
      options: studyOptions,
      placeholder: "Select Study Code",
      disabled: true,
    },
  ];

  export const subjectLabelColumns = (
    selectedAssignmentIds: number[],
    toggleSelection: (row: any, isChecked: boolean) => void,
    isAllSelected?: boolean,
    handleSelectAll?: (isChecked: boolean) => void
  ) => [
    {
      key: "select",
      sticky: true,
      // width: "50px",
      label: (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={isAllSelected || false}
            onChange={(e) => handleSelectAll?.(e.target.checked)}
          />
        </div>
      ),
      textCenter: true,
      render: (_: any, data: any) => (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={selectedAssignmentIds.includes(data.volunteerassignmentid)}
            onChange={(e) => toggleSelection(data, e.target.checked)}
          />
        </div>
      ),
    },
    {
      key: "subjectno",
      label: "Subject No",
      sticky: true,
      // width: "110px",
      render: (val: any) =>
        Number(val) >= 1 && Number(val) <= 9
          ? String(val).padStart(2, "0")
          : val,
    },
    {
      key: "barcode",
      label: "Bar Code",
    },
    // {
    //   key: "initials",
    //   label: "Initials",
    // },
    // {
    //   key: "gendertext",
    //   label: "Gender",
    // },
  ];